<div class="flex-container overflow-hidden">
  <div
    class="standart-table-wrapper"
    infiniteScroll
    (scrolled)="doScroll()"
    [scrollWindow]="false"
  >
    <ng-container *ngIf="providers; else loading">
      <table class="standart-table">
        <thead
          class="standart-table-header"
          sortable
          [directions]="sortDirections"
          (sort)="callOnSort($event)"
        >
          <tr>
            <th sortBy="lastName">name</th>
            <th sortBy="contactEmail">email</th>
            <th sortBy="recordStatus">status</th>
            <th sortBy="addressCity">address</th>
            <th sortBy="id">provider ID</th>
            <th sortBy="providerGroupId">Group ID</th>
            <th sortBy="accountNumber">Account Number</th>
            <th style="width: 130px">
              <ng-container *ngIf="!isViewOnly">
                <a
                  href="javascript:void(0);"
                  *ngIf="!!!headers.disableAdd"
                  (click)="doCreate()"
                  class="add-group-btn"
                >
                  <i class="fas fa-plus fz-16 mr-2"></i>
                  <span> Add Provider </span>
                </a>
              </ng-container>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="providers.length; else emptyRow">
          <ng-container *ngFor="let provider of providers">
            <tr>
              <td>
                {{
                  provider.firstName && provider.lastName
                    ? provider.firstName + ' ' + provider.lastName
                    : provider.firstName
                      ? provider.firstName
                      : provider.lastName
                        ? provider.lastName
                        : 'N/A'
                }}
              </td>
              <td>{{ provider.contactEmail || 'N/A' }}</td>
              <td>{{ provider.recordStatus || 'N/A' }}</td>
              <td>
                {{ provider.addressLine1 }} {{ provider.addressLine2 }}
                {{ provider.addressCity }} {{ provider.addressState }}
                {{
                  provider.addressZipcode
                    ? '(' + provider.addressZipcode + ')'
                    : ''
                }}
              </td>
              <td>{{ provider.id || 'N/A' }}</td>
              <td>{{ provider.providerGroupId || 'N/A' }}</td>
              <td>{{ provider.accountNumber || 'N/A' }}</td>
              <td>
                <div class="d-flex">
                  <div ngbDropdown container="body" class="ml-auto">
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      ngbDropdownToggle
                    >
                      <i class="fas fa-chevron-circle-down"></i>
                    </a>
                    <div class="padding-top" ngbDropdownMenu>
                      <div class="dropdown-menu-inside">
                        <button ngbDropdownItem (click)="doEdit(provider)">
                          {{ this.isViewOnly ? 'View' : 'Edit' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="moreRowsExists">
            <tr>
              <td colspan="8">
                <loader></loader>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <loader style="min-height: 100px"></loader>
</ng-template>

<ng-template #emptyRow>
  <tr>
    <td colspan="8" class="pt-3 pb-3">
      <empty-state size="sm" title="No results found"></empty-state>
    </td>
  </tr>
</ng-template>
